import { render, staticRenderFns } from "./ReportPractices.vue?vue&type=template&id=aebe7032&scoped=true&"
import script from "./ReportPractices.vue?vue&type=script&lang=js&"
export * from "./ReportPractices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebe7032",
  null
  
)

export default component.exports